import { integration } from 'ducks/entities/schema'

export const integrationsWithUserIntegrationsGraphQlResponseSchema = {
  integrations: { nodes: [integration] },
}
